import { ApiResponse, LeaveApplication } from "@/types";
import { api } from "./client";

export const leaveService = {
  getMyLeaves: async (employeeId: string) => {
    const response = await api.get<ApiResponse<LeaveApplication[]>>(
      `leaves?employeeId=${employeeId}`,
    );
    return response.responseBody.data;
  },
  getPendingLeaves: async () => {
    const response =
      await api.get<ApiResponse<LeaveApplication[]>>("leaves/pending");
    return response.responseBody.data;
  },
  getPastLeaves: async (managerId: string) => {
    const response = await api.get<ApiResponse<LeaveApplication[]>>(
      `leaves?managerId=${managerId}&status=APPROVED,REJECTED,CANCELLED`,
    );
    return response.responseBody.data;
  },
  create: async (
    data: Omit<
      LeaveApplication,
      | "id"
      | "status"
      | "appliedDate"
      | "employeeId"
      | "employeeName"
      | "managerId"
    >,
  ) => {
    return api.post<LeaveApplication>("leaves", data);
  },
  approve: async (id: string) => {
    return api.post<LeaveApplication>(`leaves/${id}/approve`, {});
  },
  reject: async (id: string, managerRemark: string) => {
    return api.post<LeaveApplication>(`leaves/${id}/reject`, { managerRemark });
  },
  cancel: async (id: string) => {
    const response = await api.patch<ApiResponse<LeaveApplication>>(
      `leaves/${id}/cancel`,
      {},
    );
    return response.responseBody.data;
  },
};
